import React, { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import DeleteIcon from "assets/svgIcons/DeleteIcon";
import DatePicker from "react-datepicker";
import { getFeatureSetOption, getFeaturesList } from "../../../../constant";
import "react-datepicker/dist/react-datepicker.css";
import SearchIcon from "assets/icons/search-icon.png";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useHookstate } from "@hookstate/core";
import { PopUpContainer } from "assets/css/globle";
import UnCheckedIcon from "assets/svgIcons/RadioUncheckIcon";
import CheckedIcon from "assets/svgIcons/RadioCheckedIcon";
import RedoIcon from "assets/svgIcons/Redo";
import UndoIcon from "assets/svgIcons/Undo";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "assets/svgIcons/ExpandMoreIcon";
import CloseIcon from "assets/svgIcons/ModalCloseOutIcon";
import CopyIcon from "assets/svgIcons/CopyIcon";
import CrossIcon from "assets/svgIcons/CloseRoundIcon";
import {
  AccordionContainer,
  TableWrapper,
} from "pages/Ads/Campaigns/EditCampaign/TableStyled";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import Tooltip from "@mui/material/Tooltip";
import {
  Container,
  Header,
  Wrapper,
  Section,
  CircleBtn,
  NormalBtn,
} from "pages/Ads/Campaigns/CampaignsStyled";
import { useTranslation } from "react-i18next";
import {
  PreviewBox,
  AdPreview,
  ImagePreviewBox,
  GallerySection,
  GalleryHeading,
  CenterSection,
  SearchWrapper,
  Status,
  DescriptionSection,
  GalleryDetails,
  GalleryWrapper,
  MainDataWrapper,
  ArchivedCampaignContainerModal,
} from "pages/Ads/Campaigns/EditCampaign/EditCampaignStyled";
import { useEffect } from "react";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ADS_GLOBAL_STATE,
  MAP_GLOBAL_STATES,
  SIDENAV_GLOBAL_STATE,
  SITEID_GLOBAL_STATE,
  COMMON_COMPONENTS_STATES,
} from "globalStore/globalStore";
import { gallerySearch } from "./gallerySearch";
import { getAdImageApiCall } from "redux/reduxToolkitServices/_commonApiCalls/api";
import { headersConfigData } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { undoFunc } from "pages/Ads/functions/undoFunc";
import { redoFunc } from "pages/Ads/functions/redoFunc";

const EditCampaign = () => {
  const { t } = useTranslation();
  const { mapSideNavTabState, callSiteSelection } =
    useHookstate(MAP_GLOBAL_STATES);
  const { showTagCarsState } = useHookstate(COMMON_COMPONENTS_STATES);
  const { subNavDataState, sideDrawerActiveTabState } =
    useHookstate(SIDENAV_GLOBAL_STATE);
  const {
    publishCampButtonState,
    redirectState,
    alertMsg,
    nextTabIndex,
    nextStageName,
    shouldShowPublishNow,
  } = useHookstate(ADS_GLOBAL_STATE);
  const navigate = useNavigate();
  let singleCampaignData = {};
  const dispatch = useDispatch();
  const [prevTableData, setPrevTableData] = useState([]);
  const [sharedImages, setSharedImages] = useState(true);
  const [localImages, setLocalImages] = useState(true);
  const [dropDownValue, setDropDownValue] = useState("date");
  const [radioInputValue, setRadioInputValue] = useState("full");
  const [fullImagesArray, setFullImagesArray] = useState([]);
  const [searchFullImagesArray, setSearchFullImagesArray] = useState([]);
  const [insertClonedArray, setInsertClonedArray] = useState([]);
  const [searchInsertClonedArray, setSearchInsertClonedArray] = useState([]);
  const [lastDay] = useState();
  const [showImage, setShowImage] = useState("");
  const [descInputValue, setDescInputValue] = useState("");
  const [descError, setDescError] = useState(false);
  const { siteId, hideSubNav, hasSiteChangedAds } =
    useHookstate(SITEID_GLOBAL_STATE);
  const [activeButton, setActiveButton] = useState([]);
  const [open, setOpen] = useState(false);
  const { state } = useLocation();
  const dragItem = useRef();
  const [expanded, setExpanded] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [allCampData, setAllCampData] = useState({});
  const [undoTableData, setUndoTableData] = useState([]);
  const [redoTableData, setRedoTableData] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const { getCampaignsStateData, siteSettingsData } = useSelector(
    (state) => state.commonReducers
  );
  const { getAdImageData, getAdInsertImageData, getUserRole } =
    useSelector((state) => state.commonReducers) || [];
  const [archiveId, setArchiveId] = useState("");
  const [archiveCampId, setArchiveCampId] = useState("");
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [detectArchiveChange, setDetectArchiveChange] = useState(false);
  const [worksheetPayload, setWorksheetPayload] = useState({});
  const timeZoneOffset = siteSettingsData && siteSettingsData?.TimeZoneOffset;

  singleCampaignData = state?.filteredData[0];

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 444,
    bgcolor: "#fff",
    borderRadius: "5px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  const campaignContainerModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 605,
    padding: "0",
    borderRadius: "5px",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "15px",
  };

  useEffect(() => {
    if (hasSiteChangedAds.get()) {
      mapSideNavTabState.set("Campaigns");
      hasSiteChangedAds.set(false);
    }
  }, [siteId.get()]);

  useEffect(() => {
    setStartDate(
      singleCampaignData?.startDateUtc != null
        ? new Date(
            moment
              .utc(singleCampaignData?.startDateUtc)
              .utcOffset(-siteSettingsData?.TimeZoneOffset)
              .format("DD-MMM-YYYY")
          )
        : null
    );
    setEndDate(
      singleCampaignData?.endDateUtc != null
        ? new Date(
            moment
              .utc(singleCampaignData?.endDateUtc)
              .utcOffset(-siteSettingsData?.TimeZoneOffset)
              .format("DD-MMM-YYYY")
          )
        : null
    );
    setDescInputValue(singleCampaignData?.Description);
    setPrevTableData(singleCampaignData?.courses);
  }, []);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getImageGalleryServices(siteId.get()));
    dispatch(COMMON_SERVICES.getCampaignsServices(siteId.get()));
    dispatch(COMMON_SERVICES.getSiteSettingsServices(siteId.get()));

    if (singleCampaignData != undefined) {
      let length = singleCampaignData?.courses?.length;
      let buttonStatus = Array(length).fill(false);
      setActiveButton(buttonStatus);
      setTableData(singleCampaignData?.courses);
    }
  }, [siteId.get()]);

  useEffect(() => {
    setAllCampData(singleCampaignData);
  }, [singleCampaignData]);

  useEffect(() => {
    let images = [];
    getCampaignsStateData &&
      getCampaignsStateData?.images?.map(async (item) => {
        const { id } = item;
        let response = await getAdImageApiCall(id, headersConfigData);
        let imageBlob = await response.blob();
        let reader = new FileReader();
        reader.readAsDataURL(imageBlob);

        reader.onloadend = () => {
          let base64data = reader.result;
          images = [...images, { base64data, ...item }];
          setFullImagesArray(images);
          setSearchFullImagesArray(images);
        };
      });
  }, [getCampaignsStateData]);

  useEffect(() => {
    let images = [];
    getCampaignsStateData &&
      getCampaignsStateData?.images?.map(async (item) => {
        if (item?.fullPage === false) {
          const { id } = item;
          let response = await getAdImageApiCall(id, headersConfigData);
          let imageBlob = await response.blob();
          let reader = new FileReader();
          reader.readAsDataURL(imageBlob);

          reader.onloadend = () => {
            let base64data = reader.result;
            images = [...images, { base64data, ...item }];
            setInsertClonedArray(images);
            setSearchInsertClonedArray(images);
          };
        }
      });
  }, [getCampaignsStateData]);

  useEffect(() => {
    if (getAdImageData)
      setFullImagesArray(JSON.parse(JSON.stringify(getAdImageData)));
  }, [getAdImageData]);

  useEffect(() => {
    if (getAdInsertImageData)
      setInsertClonedArray(JSON.parse(JSON.stringify(getAdInsertImageData)));
  }, [getAdInsertImageData]);

  useEffect(() => {
    let chkDate = moment(lastDay).isAfter(new Date(), "day");
    publishCampButtonState.set(chkDate);
  }, [lastDay]);

  useEffect(() => {
    if (startDate > endDate) setEndDate(startDate);
  }, [startDate]);

  useEffect(() => {
    if (startDate > endDate) setStartDate(endDate);
  }, [endDate]);

  useEffect(() => {
    let changed = JSON.parse(
      JSON.stringify(tableData).replace(
        /,"modified":false|,"modified":true/g,
        ""
      )
    );
    let original = JSON.parse(
      JSON.stringify(prevTableData).replace(
        /,"modified":false|,"modified":true/g,
        ""
      )
    );

    for (let i = 0; i < tableData.length; i++) {
      if (JSON.stringify(original[i]) === JSON.stringify(changed[i]))
        activeButton[i] = false;
      else activeButton[i] = true;

      setActiveButton([...activeButton]);
    }
  }, [tableData]);

  useEffect(() => {
    if (activeButton && activeButton.length !== 0) {
      let detactChanges = activeButton.some((it) => {
        if (it) {
          return true;
        } else {
          return false;
        }
      });

      if (detactChanges) {
        redirectState.set(true);
      } else {
        redirectState.set(false);
      }
    }
  }, [activeButton]);

  //########Modal for Loading Archive##############//
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setDetectArchiveChange(false);
    setArchiveId("");
  };
  //########Modal for Loading Archive##############//

  const handleChange = (panel) => () => {
    setExpanded(expanded === panel ? false : panel);
  };

  //#################Load Archive section################//

  const modifiedArchive = [];
  getCampaignsStateData?.archives?.forEach((c) => {
    const obj = {
      ...c,
    };
    modifiedArchive.push(obj);
  });

  function verboseToDate(vd) {
    if (vd?.year === undefined) {
      return;
    } else {
      return new Date(
        Date.UTC(vd.year, vd.month - 1, vd.day, vd.hour, vd.minute, vd.second)
      );
    }
  }

  function campPayload(singleCampaignData) {
    let newPayload = {};

    newPayload.Id = singleCampaignData?.Id;
    newPayload.Description = descInputValue;
    newPayload.SiteId = singleCampaignData?.SiteId;
    newPayload.baseVersion = singleCampaignData?.baseVersion;
    newPayload.lastModifiedUtc = singleCampaignData?.lastModifiedUtc;
    newPayload.lastModifiedBy = singleCampaignData?.lastModifiedBy;
    newPayload.welcomeAd = allCampData?.welcomeAd;
    newPayload.fbAd = allCampData?.fbAd;
    newPayload.videoTags = singleCampaignData?.videoTags;
    newPayload.startDateUtc = midnightLocal(startDate).toISOString();
    newPayload.endDateUtc = midnightLocal(endDate).toISOString();
    newPayload.tournamentId = singleCampaignData?.tournamentId;
    newPayload.tournamentName = singleCampaignData?.tournamentName;

    return newPayload;
  }

  function midnightLocal(time) {
    let result = moment(time).local(); // put in local mode so settings apply to local time
    result.utcOffset(-siteSettingsData?.TimeZoneOffset); // set timezone to match course
    result.hours(0).minutes(0).seconds(0).milliseconds(0); // set to midnight course time
    return result;
  }

  function sortAndFilter(type, arr) {
    if (type === "desc") {
      return arr?.sort((a, b) => {
        return a.description > b.description
          ? 1
          : a.description < b.description
          ? -1
          : 0;
      });
    } else if (type === "file") {
      return arr?.sort((a, b) => {
        let fA = a.filename.toUpperCase();
        let fB = b.filename.toUpperCase();
        return fA > fB ? 1 : fA < fB ? -1 : 0;
      });
    } else if (type === "date") {
      return arr?.sort((a, b) => {
        return verboseToDate(b?.uploadedUtc) - verboseToDate(a?.uploadedUtc);
      });
    } else {
      return arr?.sort((a, b) => {
        return a?.size - b?.size;
      });
    }
  }

  function renderImage(evt, arr) {
    if (Number(evt.target.id) === 0) {
      return;
    }
    imageName(evt.target.id);
    const returnedElem =
      arr?.length !== 0 &&
      arr?.filter((item) => {
        return item?.id === Number(evt.target.id);
      });

    setShowImage(returnedElem[0]);
  }
  const navigateToCampaigns = ()=>{
    mapSideNavTabState.set("Campaigns");
    navigate("/ads");
  }
  function modifiedDate() {
    let result = moment.utc(singleCampaignData?.lastModifiedUtc); // put in local mode so settings apply to local time
    result.utcOffset(-timeZoneOffset); // set timezone to match course
    return result.format("DD-MMM-YYYY hh:mm a");
  }

  function worksheet() {
    let bv = singleCampaignData?.baseVersion;
    let arr = getCampaignsStateData?.archives;
    let results = arr?.filter((e) => e?.version === bv);

    let basedon = results[0];
    return {
      version: basedon
        ? "Version " + basedon?.version + " - " + basedon?.comment
        : "Version " + singleCampaignData?.baseVersion,

      date: singleCampaignData?.lastModifiedUtc?.toString(), // verboseDateToString(baseModel.lastModified),
      by: singleCampaignData?.lastModifiedBy,
    };
  }
  //##########Modal for Loading Archive################//

  function descOrName(image) {
    if (image.description) return image.description;
    return image.filename;
  }

  function getImageById(imageId) {
    if (getCampaignsStateData?.images) {
      let result = getCampaignsStateData?.images?.filter(
        (e) => e.id === imageId
      );
      if (result.length > 0) {
        return result[0];
      }
    }
    return null;
  }

  function imageName(imageId) {
    if (imageId) {
      let image = getImageById(imageId);
      if (image) {
        return descOrName(image);
      }
    }
    return "";
  }

  function tablePayload(
    tableDataInfo,
    courseDetail,
    singleCampData,
    courseIndex
  ) {
    let newTablePayload = {};
    newTablePayload.id = courseDetail?.id;
    newTablePayload.CampaignId = singleCampData?.Id;
    newTablePayload.SiteId = singleCampData?.SiteId;
    newTablePayload.name = courseDetail?.name;
    newTablePayload.CourseNum = courseDetail?.number;
    newTablePayload.rotationAd = tableDataInfo[courseIndex]?.rotationAd;
    newTablePayload.HoleAds = tableDataInfo[courseIndex]?.holes;

    return newTablePayload;
  }

  function handleSaveEditDesc() {
    let payload = campPayload(singleCampaignData);

    dispatch(
      COMMON_SERVICES.saveTableCampaignDetailServices(
        siteId.get(),
        worksheetPayload
      )
    );

    setUndoTableData([]);
    setRedoTableData([]);
    redirectState.set(false);
    dragItem.current = null;
    shouldShowPublishNow.set(true);

    if (!descError) {
			   
      dispatch(COMMON_SERVICES.saveWorksheetServices(payload)).then(() => {
				 
		 
					
        mapSideNavTabState.set("Campaigns");
        dispatch(COMMON_SERVICES.getWelcomeAdsImageServices(siteId.get()));
      });
    }
  }

  const dragStart = (val) => {
    dragItem.current = val;
  };

  const dragOver = (e) => {
    e.preventDefault();
  };
  // ************************************************************ Drag Drop ****************************************************************************************

  const dragDrop = (
    e,
    type,
    index,
    courseIndex,
    courseDetail,
    singleCampData
  ) => {
    undoTableData.push(tableData);
    if (dragItem.current.id) {
      const changeStatusButton = [...activeButton];
      changeStatusButton[courseIndex] = true;
    }

    const { id } = e.target;

    let tableDataTemp = JSON.parse(JSON.stringify(tableData));
    let allCampDataTemp = JSON.parse(JSON.stringify(allCampData));

    if (type === "textField3") {
      allCampDataTemp[id].imageId = dragItem.current.id;
      allCampDataTemp[id].modified = true;
      setAllCampData(allCampDataTemp);
    } else if (type === "tableFieldData") {
      if (dragItem.current.fullPage && id.includes("teeFullImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && id.includes("teeInsertImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && id.includes("fairwayFullImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (
        !dragItem.current.fullPage &&
        id.includes("fairwayInsertImage")
      ) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && id.includes("greenFullImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (
        !dragItem.current.fullPage &&
        id.includes("greenInsertImage")
      ) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && id.includes("g2tFullImage")) {
        tableDataTemp[courseIndex].holes[index][id].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][id].modified = true;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && id.includes("rotationAd")) {
        tableDataTemp[courseIndex][id].imageId = dragItem.current.id;
        tableDataTemp[courseIndex][id].modified = true;
        setTableData(tableDataTemp);
      }
    } else if (type.includes("tableFieldHeader")) {
      if (dragItem.current.fullPage && type.includes("TeeTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["teeFullImage"].imageId = dragItem.current.id;
          value["teeFullImage"].modified = true;

          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && type.includes("TeeTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["teeInsertImage"].imageId = dragItem.current.id;
          value["teeInsertImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && type.includes("FairwayTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["fairwayFullImage"].imageId = dragItem.current.id;
          value["fairwayFullImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && type.includes("FairwayTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["fairwayInsertImage"].imageId = dragItem.current.id;
          value["fairwayInsertImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && type.includes("GreenTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["greenFullImage"].imageId = dragItem.current.id;
          value["greenFullImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && type.includes("GreenTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["greenInsertImage"].imageId = dragItem.current.id;
          value["greenInsertImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && type.includes("Green2Table")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["g2tFullImage"].imageId = dragItem.current.id;
          value["g2tFullImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (dragItem.current.fullPage && type.includes("AllTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["g2tFullImage"].imageId = dragItem.current.id;
          value["g2tFullImage"].modified = true;
          value["greenFullImage"].imageId = dragItem.current.id;
          value["greenFullImage"].modified = true;
          value["fairwayFullImage"].imageId = dragItem.current.id;
          value["fairwayFullImage"].modified = true;
          value["teeFullImage"].imageId = dragItem.current.id;
          value["teeFullImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage && type.includes("AllTable")) {
        let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
          value["greenInsertImage"].imageId = dragItem.current.id;
          value["greenInsertImage"].modified = true;
          value["fairwayInsertImage"].imageId = dragItem.current.id;
          value["fairwayInsertImage"].modified = true;
          value["teeInsertImage"].imageId = dragItem.current.id;
          value["teeInsertImage"].modified = true;
          return value;
        });
        tableDataTemp[courseIndex].holes = tableDataTemp1;
        setTableData(tableDataTemp);
      }
    } else if (type === "AllRowTable") {
      if (dragItem.current.fullPage) {
        tableDataTemp[courseIndex].holes[index]["teeFullImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index]["teeFullImage"].modified = true;
        tableDataTemp[courseIndex].holes[index]["fairwayFullImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "fairwayFullImage"
        ].modified = true;
        tableDataTemp[courseIndex].holes[index]["greenFullImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "greenFullImage"
        ].modified = true;
        tableDataTemp[courseIndex].holes[index]["g2tFullImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index]["g2tFullImage"].modified = true;

        setTableData(tableDataTemp);
      } else if (!dragItem.current.fullPage) {
        tableDataTemp[courseIndex].holes[index]["teeInsertImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "teeInsertImage"
        ].modified = true;
        tableDataTemp[courseIndex].holes[index]["fairwayInsertImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "fairwayInsertImage"
        ].modified = true;
        tableDataTemp[courseIndex].holes[index]["greenInsertImage"].imageId =
          dragItem.current.id;
        tableDataTemp[courseIndex].holes[index][
          "greenInsertImage"
        ].modified = true;
        setTableData(tableDataTemp);
      }
    }

    setPrevTableData(tableData);
    setWorksheetPayload(
      tablePayload(tableDataTemp, courseDetail, singleCampData, courseIndex)
    );
  };

  const yesFunc = () => {
    redirectState.set(false);
    alertMsg.set(false);

    hideSubNav.set(true);
    if (nextStageName.get() === "siteSelection") {
      callSiteSelection.set(true);
      mapSideNavTabState.set("Campaigns");
      return;
    }
    navigate(`/${nextStageName.get().toLowerCase()}`);
    let activeTab = nextTabIndex.get();
    let activeName = nextStageName.get();
    sideDrawerActiveTabState.set(activeTab);
    subNavDataState.set(activeName);

    localStorage.setItem("sideDrawerActiveTabState", nextTabIndex.get());

    localStorage.setItem("subNavState", "true");
    localStorage.setItem("subNavDataState", nextStageName.get());

    if (
      nextTabIndex.get() == localStorage.getItem("sideDrawerActiveTabState")
    ) {
      mapSideNavTabState.set("Campaigns");
    }

    if (nextStageName.get() !== "FLEET") {
      showTagCarsState.set(false);
    }
  };

  // ************************************************************ Delete All ****************************************************************************************
  function deleteAllDesc(
    e,
    type,
    index,
    courseIndex,
    courseDetail,
    singleCampData
  ) {
    e.stopPropagation();

    undoTableData.push(tableData);
    setTimeout(() => {
      const changeStatusButton = [...activeButton];
      changeStatusButton[courseIndex] = true;

      const { id } = e.target;
      let tableDataTemp = JSON.parse(JSON.stringify(tableData));

      if (type === "tableFieldData") {
        if (id.includes("teeFullImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("teeInsertImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("fairwayFullImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("fairwayInsertImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("greenFullImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("greenInsertImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("g2tFullImage")) {
          tableDataTemp[courseIndex].holes[index][id].imageId = 0;
          tableDataTemp[courseIndex].holes[index][id].modified = true;
          setTableData(tableDataTemp);
        } else if (id.includes("rotationAd")) {
          tableDataTemp[courseIndex][id].imageId = 0;
          tableDataTemp[courseIndex][id].modified = true;
          setTableData(tableDataTemp);
        }
      } else if (type.includes("tableFieldHeader")) {
        if (type.includes("TeeTable")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["teeFullImage"].imageId = 0;
            value["teeFullImage"].modified = true;
            value["teeInsertImage"].imageId = 0;
            value["teeInsertImage"].modified = true;
            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        } else if (type.includes("FairwayTable")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["fairwayFullImage"].imageId = 0;
            value["fairwayFullImage"].modified = true;
            value["fairwayInsertImage"].imageId = 0;
            value["fairwayInsertImage"].modified = true;
            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        } else if (type.includes("GreenTable")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["greenFullImage"].imageId = 0;
            value["greenFullImage"].modified = true;
            value["greenInsertImage"].imageId = 0;
            value["greenInsertImage"].modified = true;
            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        } else if (type.includes("Green2Table")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["g2tFullImage"].imageId = 0;
            value["g2tFullImage"].modified = true;

            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        } else if (type.includes("RemoveAllTable")) {
          let tableDataTemp1 = tableDataTemp[courseIndex].holes.map((value) => {
            value["g2tFullImage"].imageId = 0;
            value["g2tFullImage"].modified = true;
            value["greenFullImage"].imageId = 0;
            value["greenFullImage"].modified = true;
            value["fairwayFullImage"].imageId = 0;
            value["fairwayFullImage"].modified = true;
            value["teeFullImage"].imageId = 0;
            value["teeFullImage"].modified = true;
            value["greenInsertImage"].imageId = 0;
            value["greenInsertImage"].modified = true;
            value["fairwayInsertImage"].imageId = 0;
            value["fairwayInsertImage"].modified = true;
            value["teeInsertImage"].imageId = 0;
            value["teeInsertImage"].modified = true;
            return value;
          });
          tableDataTemp[courseIndex].holes = tableDataTemp1;
          setTableData(tableDataTemp);
        }
      }

      setPrevTableData(tableData);
      setWorksheetPayload(
        tablePayload(tableDataTemp, courseDetail, singleCampData, courseIndex)
      );
    }, 5);
  }

  const handleChangeArchive = (event) => {
    setArchiveId(event.target.value);
    setDetectArchiveChange(true);
  };

  const handleOpenOnLoad = (rowID) => {
    setOpenConfirmation(true);
    setArchiveCampId(rowID);
  };

  const handleOpenConfirmation = () => {
    setDetectArchiveChange(false);
    dispatch(COMMON_SERVICES.getArchiveServices(archiveId, archiveCampId)).then(
      () => {
        setOpenConfirmation(false);
        handleClose();
        mapSideNavTabState.set("Campaigns");
      }
    );
  };

  const handleCloseConfirmation = () => setOpenConfirmation(false);

  const handleStartDate = (date) => {
    if (date) {
      date.setHours(4);
      date.setMinutes(0);
      date.setSeconds(0);
      setStartDate(date);
    }
  };

  const handleEndDate = (date) => {
    if (date) {
      date.setHours(4);
      date.setMinutes(0);
      date.setSeconds(0);
      setEndDate(date);
    }
  };

  function verboseDateToString(vd, format) {
    let m = moment(
      new Date(
        Date.UTC(vd.year, vd.month - 1, vd.day, vd.hour, vd.minute, vd.second)
      )
    );
    if (format) {
      return m.format(format);
    } else {
      return m.format("ddd DD/MMM/YY HH:mm:ss");
    }
  }

  function findDefaultCampaignMissingImages() {
    if (singleCampaignData?.Description === "Default campaign") {
      return (
        (singleCampaignData?.welcomeAd &&
          singleCampaignData?.welcomeAd.imageId === 0) ||
        (singleCampaignData?.fbAd && singleCampaignData?.fbAd.imageId === 0)
      );
    }
  }

  return (
    <Container>
      <Header className="edit-campaign-header">
        <Tooltip
          title={t("Load_previously_published_ad_set_to_worksheet")}
          className="title"
        >
          <CircleBtn onClick={handleOpen}>
            <DeleteIcon
              color="#fff"
              width={10}
              height={12}
              disabled={
                getFeatureSetOption(
                  siteSettingsData.Features,
                  getFeaturesList().adman_event
                ) &&
                getUserRole &&
                getUserRole.Role !== 6
              }
            />
            {t("Load_from_archive")}
          </CircleBtn>
        </Tooltip>
        <div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={campaignContainerModalStyle}>
              <ArchivedCampaignContainerModal>
                <div className="header">
                  <h3>{t("Load_ads_from_archived_campaign")}</h3>
                  <button>
                    <CloseIcon onClick={handleClose} />
                  </button>
                </div>
                <div className="modal-body">
                  <div className="input-wrapper">
                    <p className="label">{t("Select_archived_campaign")}:</p>
                    <FormControl fullWidth>
                      <InputLabel id="select-label">
                        Choose Version..
                      </InputLabel>
                      <Select
                        disabled={getFeatureSetOption(
                          siteSettingsData.Features,
                          getFeaturesList().adman_event
                        )}
                        labelId="select-label"
                        id="demo-simple-select"
                        value={archiveId}
                        label="Choose Version.."
                        onChange={handleChangeArchive}
                      >
                        {modifiedArchive?.map((ad, index) => (
                          <MenuItem key={index} value={ad.version}>
                            {"Ver " +
                              ad.version +
                              " | " +
                              ad.comment +
                              " [" +
                              verboseDateToString(
                                ad.publishedUtc,
                                "DD-MMM-YY"
                              ) +
                              " " +
                              ad.publishedBy +
                              "]"}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="action-btn">
                    <button
                      disabled={
                        !detectArchiveChange ||
                        getFeatureSetOption(
                          siteSettingsData.Features,
                          getFeaturesList().adman_event
                        )
                      }
                      onClick={() => handleOpenOnLoad(singleCampaignData.Id)}
                    >
                      {t("Load")}
                    </button>
                    <button
                      onClick={() => {
                        handleClose();
                        setDetectArchiveChange(false);
                        setArchiveId("");
                      }}
                    >
                      {t("Cancel")}
                    </button>
                  </div>
                </div>
              </ArchivedCampaignContainerModal>
            </Box>
          </Modal>
        </div>

        <Modal
          open={openConfirmation}
          onClose={handleCloseConfirmation}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <PopUpContainer>
              <h2>{t("Confirm_load")}</h2>
              <p>{t("Load_campaign_from_archive")}?</p>
              <div className="action-btn">
                <button
                  className="primary"
                  onClick={() => handleOpenConfirmation()}
                  variant="contained"
                >
                  {t("Yes")}
                </button>
                <button onClick={() => handleCloseConfirmation()}>
                  {t("No")}
                </button>
              </div>
            </PopUpContainer>
          </Box>
        </Modal>
        
        <div className="input-wrapper">
          <p>{t("Last_modified")} :</p>
          <p className="date">
            {modifiedDate()} by {worksheet().by}
          </p>
        </div>
        <Tooltip title={t("Close")}>
          <CircleBtn
            className="circle-btn"
            onClick={(e) => {
              navigateToCampaigns()
            }}
          >
            <CloseIcon height={18} width={20}></CloseIcon> {t("Close")}{" "}
          </CircleBtn>
        </Tooltip>
      </Header>

      <Wrapper>
        <CenterSection>
          <div>
            <DescriptionSection className="description-section">
              <div className="main-wrapper">
                <div className="input-wrapper">
                  <p>{t("Description")} :</p>
                  <input
                    type="text"
                    value={descInputValue}
                    onChange={(e) => {
                      setDescInputValue(e.target.value);

                      if (e.target.value.trim().length > 0) {
                        setDescError(false);
                      } else {
                        setDescError(true);
                      }
                    }}
                  />
                  {descError ? (
                    <p className="error-msg"> Please Enter The Description </p>
                  ) : null}
                </div>

                {singleCampaignData?.Description === "Default campaign" ||
                singleCampaignData?.startDateUtc === null ? (
                  <></>
                ) : (
                  <div className="input-wrapper">
                    <p className="label">{t("First_day")}</p>
                    <DatePicker
                      dateFormat = "dd-MMM-yyyy"
                      selected={startDate}
                      onChange={(date) => handleStartDate(date)}
                      selectsStart
                      startDate={startDate}
                      endDate={endDate}
                    />
                  </div>
                )}

                {singleCampaignData?.Description === "Default campaign" ||
                singleCampaignData?.endDateUtc === null ? (
                  <></>
                ) : (
                  <div className="input-wrapper">
                    <>
                      <p className="label">{t("Last_day")}</p>
                      <DatePicker
                        dateFormat = "dd-MMM-yyyy"
                        selected={endDate}
                        onChange={(date) => handleEndDate(date)}
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                      />
                    </>
                  </div>
                )}

                <div className="input-wrapper">
                  <p
                    style={{
                      color: findDefaultCampaignMissingImages() ? "red" : "",
                    }}
                  >
                    {t("Welcome_ad")} :
                  </p>
                  <Tooltip title={imageName(allCampData?.welcomeAd?.imageId)}>
                    <span
                      id="welcomeAd"
                      onDragOver={(e) => dragOver(e)}
                      onDrop={(e) => dragDrop(e, "textField3")}
                      onClick={(e) => dragDrop(e, "textField3")}
                      className="editable"
                    >
                      {imageName(allCampData?.welcomeAd?.imageId) !== "" ? (
                        <>{imageName(allCampData?.welcomeAd?.imageId)}</>
                      ) : (
                        <></>
                      )}
                    </span>
                  </Tooltip>
                </div>
                <div className="input-wrapper">
                  <p
                    style={{
                      color: findDefaultCampaignMissingImages() ? "red" : "",
                    }}
                  >
                    {t("F&B_Ad")} :
                  </p>
                  <Tooltip title={imageName(allCampData?.fbAd?.imageId)}>
                    <span
                      id="fbAd"
                      onDragOver={(e) => dragOver(e)}
                      onDrop={(e) => dragDrop(e, "textField3")}
                      onClick={(e) => dragDrop(e, "textField3")}
                      className="editable"
                    >
                      {imageName(allCampData?.fbAd?.imageId) !== "" ? (
                        <>{imageName(allCampData?.fbAd?.imageId)}</>
                      ) : (
                        <></>
                      )}
                    </span>
                  </Tooltip>
                </div>
                {findDefaultCampaignMissingImages() ? (
                  <p
                    style={{
                      color: "red",
                    }}
                  >
                    Missing Welcome and/or F&B images
                  </p>
                ) : (
                  <></>
                )}
              </div>

              <NormalBtn className="circle-btn">
                <Button
                  variant="outlined"
                  onClick={() => {
                    alertMsg.set(true);
                  }}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  variant="outlined"
                  style={{ margin: 5 }}
                  className={"active"}
                  onClick={handleSaveEditDesc}
                >
                  {t("Save")}
                </Button>
              </NormalBtn>

            </DescriptionSection>
            <Section className="campaigns-main-section">
              <MainDataWrapper>
                {tableData &&
                  tableData?.length !== 0 &&
                  tableData?.map((course, index) => {
                    let panelString = `panel ${index + 1}`;
                    return (
                      <AccordionContainer>
                        <Accordion expanded={expanded === panelString}>
                          <AccordionSummary
                            expandIcon={
                              <ExpandMoreIcon
                                onClick={handleChange(panelString)}
                              />
                            }
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                          >
                            <div className="header">
                              <div className="left-wrapper">
                                <h4>{course?.name}</h4>
                                <div className="input-wrapper">
                                  <p>{t("Default_insert_ad")}</p>

                                  <span
                                    id="rotationAd"
                                    style={{
                                      padding: "0",
                                      fontSize: "12px",
                                      width: "80px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "inline-flex",
                                      height: "24px",
                                      border: "1px solid #636f7c",
                                      borderRadius: "3px",
                                      padding: "2px",
                                    }}
                                    onDragOver={(e) => dragOver(e)}
                                    onDrop={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldData",
                                        index,
                                        index,
                                        course,
                                        singleCampaignData
                                      )
                                    }
                                    onClick={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldData",
                                        index,
                                        index,
                                        course,
                                        singleCampaignData
                                      )
                                    }
                                  >
                                    {imageName(course?.rotationAd?.imageId) !==
                                    "" ? (
                                      <>
                                        <p
                                          id="rotationAd"
                                          style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            fontSize: "12px",
                                          }}
                                        >
                                          {imageName(
                                            course?.rotationAd?.imageId
                                          )}
                                        </p>
                                        <button
                                          id="rotationAd"
                                          style={{ border: "none" }}
                                          onClick={(e) =>
                                            deleteAllDesc(
                                              e,
                                              "tableFieldData",
                                              index,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          <CrossIcon
                                            width={12}
                                            height={12}
                                            pointerEvents="none"
                                          />
                                        </button>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </span>
                                </div>
                              </div>
                              <div className="button-wrapper">
                                <Tooltip title={t("Redo")} className="title">
                                  <button
                                    onClick={(e) =>
                                      redoFunc(
                                        tableData,
                                        setTableData,
                                        redoTableData,
                                        undoTableData
                                      )
                                    }
                                  >
                                    <RedoIcon />
                                  </button>
                                </Tooltip>
                                <Tooltip title={t("Undo")} className="title">
                                  <button
                                    onClick={(e) =>
                                      undoFunc(
                                        tableData,
                                        setTableData,
                                        undoTableData,
                                        redoTableData
                                      )
                                    }
                                  >
                                    <UndoIcon />
                                  </button>
                                </Tooltip>
                              </div>
                            </div>
                          </AccordionSummary>
                          <AccordionDetails>
                            <TableWrapper>
                              <table>
                                <tr>
                                  <th
                                    id="all"
                                    onDragOver={(e) => dragOver(e)}
                                    onDrop={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldHeaderAllTable",
                                        index,
                                        index,
                                        course,
                                        singleCampaignData
                                      )
                                    }
                                  >
                                    <span>{t("All")}</span>
                                    <div className="icon-wrapper">
                                      <Tooltip title={t("Copy_All")}>
                                        <button
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldHeaderAllTable",
                                              index,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          <CopyIcon width={20} height={20} />
                                        </button>
                                      </Tooltip>
                                      <Tooltip title={t("Delete_All")}>
                                        <button
                                          id="removeAll"
                                          onClick={(e) =>
                                            deleteAllDesc(
                                              e,
                                              "tableFieldHeaderRemoveAllTable",
                                              index,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          <CrossIcon pointerEvents="none" />
                                        </button>
                                      </Tooltip>
                                    </div>
                                  </th>
                                  {(!getFeatureSetOption(
                                    siteSettingsData.Features,
                                    getFeaturesList().adman_pro
                                  ) ||
                                    (getUserRole && getUserRole.Role === 1)) && (
                                    <th
                                      colSpan="2"
                                      id="tee"
                                      onDragOver={(e) => dragOver(e)}
                                      onDrop={(e) =>
                                        dragDrop(
                                          e,
                                          "tableFieldHeaderTeeTable",
                                          index,
                                          index,
                                          course,
                                          singleCampaignData
                                        )
                                      }
                                    >
                                      <span>Tee</span>
                                      <div className="icon-wrapper gap">
                                        <Tooltip title={t("Copy")}>
                                          <button
                                            onClick={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldHeaderTeeTable",
                                                index,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                          >
													   
														  
                                            <CopyIcon width={20} height={20} />
												
                                          </button>
                                        </Tooltip>
                                        <Tooltip title={t("Delete")}>
                                          <button
                                            id="removeTee"
                                            onClick={(e) =>
                                              deleteAllDesc(
                                                e,
                                                "tableFieldHeaderTeeTable",
                                                index,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                          >
                                            <CrossIcon pointerEvents="none" />
                                          </button>
                                        </Tooltip>
                                      </div>
                                    </th>
                                  )}

                                  <th
                                    colSpan="2"
                                    id="fairway"
                                    onDragOver={(e) => dragOver(e)}
                                    onDrop={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldHeaderFairwayTable",
                                        index,
                                        index,
                                        course,
                                        singleCampaignData
                                      )
                                    }
                                  >
                                    <span>{t("Fairway")}</span>
                                    <div className="icon-wrapper gap">
                                      <Tooltip title={t("Copy")}>
                                        <button
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldHeaderFairwayTable",
                                              index,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          <CopyIcon width={20} height={20} />
                                        </button>
                                      </Tooltip>
                                      <Tooltip title={t("Delete")}>
                                        <button
                                          id="removeFairway"
                                          onClick={(e) =>
                                            deleteAllDesc(
                                              e,
                                              "tableFieldHeaderFairwayTable",
                                              index,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          <CrossIcon />
                                        </button>
                                      </Tooltip>
                                    </div>
                                  </th>
                                  {(!getFeatureSetOption(
                                    siteSettingsData.Features,
                                    getFeaturesList().adman_pro
                                  ) ||
                                    (getUserRole && getUserRole.Role === 1)) && (
                                    <th
                                      colSpan="2"
                                      id="green"
                                      onDragOver={(e) => dragOver(e)}
                                      onDrop={(e) =>
                                        dragDrop(
                                          e,
                                          "tableFieldHeaderGreenTable",
                                          index,
                                          index,
                                          course,
                                          singleCampaignData
                                        )
                                      }
                                    >
                                      <span>{t("Green")}</span>
                                      <div className="icon-wrapper gap">
                                        <Tooltip title={t("Copy")}>
                                          <button
                                            onClick={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldHeaderGreenTable",
                                                index,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                          >
													   
														  
                                            <CopyIcon width={20} height={20} />
												
                                          </button>
                                        </Tooltip>
                                        <Tooltip title={t("Delete")}>
                                          <button
                                            id="removeGreen"
                                            onClick={(e) =>
                                              deleteAllDesc(
                                                e,
                                                "tableFieldHeaderGreenTable",
                                                index,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                          >
                                            <CrossIcon />
                                          </button>
                                        </Tooltip>
                                      </div>
                                    </th>
                                  )}

                                  <th
                                    id="green2t"
                                    onDragOver={(e) => dragOver(e)}
                                    onDrop={(e) =>
                                      dragDrop(
                                        e,
                                        "tableFieldHeaderGreen2Table",
                                        index,
                                        index,
                                        course,
                                        singleCampaignData
                                      )
                                    }
                                  >
                                    <span>{t("Green-to-Tee")}</span>{" "}
                                    <div className="icon-wrapper gap">
                                      <Tooltip title={t("Copy")}>
                                        <button
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldHeaderGreen2Table",
                                              index,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          <CopyIcon width={20} height={20} />
                                        </button>
                                      </Tooltip>
                                      <Tooltip title={t("Delete")}>
                                        <button
                                          id="removeG2T"
                                          onClick={(e) =>
                                            deleteAllDesc(
                                              e,
                                              "tableFieldHeaderGreen2Table",
                                              index,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          <CrossIcon />
                                        </button>
                                      </Tooltip>
                                    </div>
                                  </th>
                                </tr>
                                <tr className="sec-header">
                                  <th>{t("Hole")}</th>
                                  {(!getFeatureSetOption(
                                    siteSettingsData.Features,
                                    getFeaturesList().adman_pro
                                  ) ||
                                    (getUserRole && getUserRole.Role === 1)) && (
																 
                                    <th colSpan="2">
                                      <div className="page-type">
                                        <span>{t("Full_page")}</span>
                                        <span>{t("Insert")}</span>
                                      </div>
                                    </th>
                                  )}

                                  <th colSpan="2">
                                    <div className="page-type">
                                      <span>{t("Full_page")}</span>
                                      <span>{t("Insert")}</span>
                                    </div>
                                  </th>
                                  {(!getFeatureSetOption(
                                    siteSettingsData.Features,
                                    getFeaturesList().adman_pro
                                  ) ||
                                    (getUserRole && getUserRole.Role == 1)) && (
																  
                                    <th colSpan="2">
                                      <div className="page-type">
                                        <span>{t("Full_page")}</span>
                                        <span>{t("Insert")}</span>
                                      </div>
                                    </th>
                                  )}

                                  <th>{t("Full_page")}</th>
                                </tr>
                                {course?.holes &&
                                  course?.holes?.map((hole, holeIndex) => {
                                    return (
                                      <tr>
                                        <td
                                          id="AllRow"
                                          style={{ cursor: "pointer" }}
                                          onDragOver={(e) => dragOver(e)}
                                          onDrop={(e) =>
                                            dragDrop(
                                              e,
                                              "AllRowTable",
                                              holeIndex,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "AllRowTable",
                                              holeIndex,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          {hole?.number}
                                        </td>
                                        {(!getFeatureSetOption(
                                          siteSettingsData.Features,
                                          getFeaturesList().adman_pro
                                        ) ||
                                          (getUserRole &&
                                            getUserRole.Role == 1)) && (
                                          <td
                                            id="teeFullImage"
                                            style={{ cursor: "pointer" }}
                                            onDragOver={(e) => dragOver(e)}
                                            onDrop={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldData",
                                                holeIndex,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                            onClick={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldData",
                                                holeIndex,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                          >
                                            {imageName(
                                              hole?.teeFullImage?.imageId
                                            ) !== "" ? (
                                              <>
                                                {imageName(
                                                  hole?.teeFullImage?.imageId
                                                )}
                                                <button
                                                  id="teeFullImage"
                                                  onClick={(e) =>
                                                    deleteAllDesc(
                                                      e,
                                                      "tableFieldData",
                                                      holeIndex,
                                                      index,
                                                      course,
                                                      singleCampaignData
                                                    )
                                                  }
                                                >
                                                  <CrossIcon
                                                    width={12}
                                                    height={12}
                                                    pointerEvents="none"
                                                  />
                                                </button>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        )}

                                        {(!getFeatureSetOption(
                                          siteSettingsData.Features,
                                          getFeaturesList().adman_pro
                                        ) ||
                                          (getUserRole &&
                                            getUserRole.Role === 1)) && (
                                          <td
                                            id="teeInsertImage"
                                            style={{ cursor: "pointer" }}
                                            onDragOver={(e) => dragOver(e)}
                                            onDrop={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldData",
                                                holeIndex,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                            onClick={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldData",
                                                holeIndex,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                          >
                                            {imageName(
                                              hole?.teeInsertImage?.imageId
                                            ) !== "" ? (
                                              <>
                                                {imageName(
                                                  hole?.teeInsertImage?.imageId
															   
                                                )}
                                                <button
                                                  id="teeInsertImage"
                                                  onClick={(e) =>
                                                    deleteAllDesc(
                                                      e,
                                                      "tableFieldData",
                                                      holeIndex,
                                                      index,
                                                      course,
                                                      singleCampaignData
                                                    )
                                                  }
                                                >
                                                  <CrossIcon
                                                    width={12}
                                                    height={12}
                                                    pointerEvents="none"
                                                  />
                                                </button>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        )}

                                        <td
                                          id="fairwayFullImage"
                                          style={{ cursor: "pointer" }}
                                          onDragOver={(e) => dragOver(e)}
                                          onDrop={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          {imageName(
                                            hole?.fairwayFullImage?.imageId
                                          ) !== "" ? (
                                            <>
                                              {imageName(
                                                hole?.fairwayFullImage?.imageId
                                              )}
                                              <button
                                                id="fairwayFullImage"
                                                onClick={(e) =>
                                                  deleteAllDesc(
                                                    e,
                                                    "tableFieldData",
                                                    holeIndex,
                                                    index,
                                                    course,
                                                    singleCampaignData
                                                  )
                                                }
                                              >
                                                <CrossIcon
                                                  width={12}
                                                  height={12}
                                                  pointerEvents="none"
                                                />
                                              </button>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </td>
                                        <td
                                          id="fairwayInsertImage"
                                          style={{ cursor: "pointer" }}
                                          onDragOver={(e) => dragOver(e)}
                                          onDrop={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          {imageName(
                                            hole?.fairwayInsertImage?.imageId
                                          ) !== "" ? (
                                            <>
                                              {imageName(
                                                hole?.fairwayInsertImage
                                                  ?.imageId
                                              )}
                                              <button
                                                id="fairwayInsertImage"
                                                onClick={(e) =>
                                                  deleteAllDesc(
                                                    e,
                                                    "tableFieldData",
                                                    holeIndex,
                                                    index,
                                                    course,
                                                    singleCampaignData
                                                  )
                                                }
                                              >
                                                <CrossIcon
                                                  width={12}
                                                  height={12}
                                                  pointerEvents="none"
                                                />
                                              </button>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </td>
                                        {(!getFeatureSetOption(
                                          siteSettingsData.Features,
                                          getFeaturesList().adman_pro
                                        ) ||
                                          (getUserRole &&
                                            getUserRole.Role === 1)) && (
                                          <td
                                            id="greenFullImage"
                                            style={{ cursor: "pointer" }}
                                            onDragOver={(e) => dragOver(e)}
                                            onDrop={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldData",
                                                holeIndex,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                            onClick={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldData",
                                                holeIndex,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                          >
                                            {imageName(
                                              hole?.greenFullImage?.imageId
                                            ) !== "" ? (
                                              <>
                                                {imageName(
                                                  hole?.greenFullImage?.imageId
															   
                                                )}
                                                <button
                                                  id="greenFullImage"
                                                  onClick={(e) =>
                                                    deleteAllDesc(
                                                      e,
                                                      "tableFieldData",
                                                      holeIndex,
                                                      index,
                                                      course,
                                                      singleCampaignData
                                                    )
                                                  }
                                                >
                                                  <CrossIcon
                                                    width={12}
                                                    height={12}
                                                    pointerEvents="none"
                                                  />
                                                </button>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        )}

                                        {(!getFeatureSetOption(
                                          siteSettingsData.Features,
                                          getFeaturesList().adman_pro
                                        ) ||
                                          (getUserRole &&
                                            getUserRole.Role === 1)) && (
                                          <td
                                            id="greenInsertImage"
                                            style={{ cursor: "pointer" }}
                                            onDragOver={(e) => dragOver(e)}
                                            onDrop={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldData",
                                                holeIndex,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                            onClick={(e) =>
                                              dragDrop(
                                                e,
                                                "tableFieldData",
                                                holeIndex,
                                                index,
                                                course,
                                                singleCampaignData
                                              )
                                            }
                                          >
                                            {imageName(
                                              hole?.greenInsertImage?.imageId
                                            ) !== "" ? (
                                              <>
                                                {imageName(
                                                  hole?.greenInsertImage
                                                    ?.imageId
                                                )}
                                                <button
                                                  id="greenInsertImage"
                                                  onClick={(e) =>
                                                    deleteAllDesc(
                                                      e,
                                                      "tableFieldData",
                                                      holeIndex,
                                                      index,
                                                      course,
                                                      singleCampaignData
                                                    )
                                                  }
                                                >
                                                  <CrossIcon
                                                    width={12}
                                                    height={12}
                                                    pointerEvents="none"
                                                  />
                                                </button>
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                        )}

                                        <td
                                          id="g2tFullImage"
                                          style={{ cursor: "pointer" }}
                                          onDragOver={(e) => dragOver(e)}
                                          onDrop={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                          onClick={(e) =>
                                            dragDrop(
                                              e,
                                              "tableFieldData",
                                              holeIndex,
                                              index,
                                              course,
                                              singleCampaignData
                                            )
                                          }
                                        >
                                          {imageName(
                                            hole?.g2tFullImage?.imageId
                                          ) !== "" ? (
                                            <>
                                              {imageName(
                                                hole?.g2tFullImage?.imageId
                                              )}
                                              <button
                                                id="g2tFullImage"
                                                onClick={(e) =>
                                                  deleteAllDesc(
                                                    e,
                                                    "tableFieldData",
                                                    holeIndex,
                                                    index,
                                                    course,
                                                    singleCampaignData
                                                  )
                                                }
                                              >
                                                <CrossIcon
                                                  width={12}
                                                  height={12}
                                                  pointerEvents="none"
                                                />
                                              </button>
                                            </>
                                          ) : (
                                            <></>
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </table>
                            </TableWrapper>
                          </AccordionDetails>
                        </Accordion>
                      </AccordionContainer>
                    );
                  })}
              </MainDataWrapper>
            </Section>
          </div>
          <GallerySection>
            <PreviewBox>
              <AdPreview>
                <ImagePreviewBox>
                  {showImage && (
                    <img
                      src={showImage.base64data}
                      className="full-view-image"
                      alt="AdPreviewImage"
                      onDragStart={() => dragStart(showImage)}
                      onClick={() => dragStart(showImage)}
                    />
                  )}
                </ImagePreviewBox>
              </AdPreview>
            </PreviewBox>
            <GalleryHeading>
              <h3>{t("Gallery")}</h3>
              <SearchWrapper>
                <Tooltip title={t("Type_partial_filename_to_filter_the_list")}>
                  <input
                    type="text"
                    placeholder={t("Search")}
                    onChange={(e) =>
                      gallerySearch(
                        e,
                        searchFullImagesArray,
                        setFullImagesArray,
                        searchInsertClonedArray,
                        setInsertClonedArray
                      )
                    }
                  />
                </Tooltip>
                <img src={SearchIcon} alt="search-icon" />
              </SearchWrapper>
            </GalleryHeading>
            <Status>
              <div className="row-div">
                <p className="label">{t("Status")}</p>
                <div className="btn-wrapper">
                  <Tooltip title={t("Shared")} className="title">
                    <button
                      className={sharedImages ? "active" : ""}
                      onClick={() => {
                        setSharedImages(!sharedImages);
                      }}
                    >
                      {t("Shared")}
                    </button>
                  </Tooltip>
                  <Tooltip title={t("Local")} className="title">
                    <button
                      className={localImages ? "active" : ""}
                      onClick={() => {
                        setLocalImages(!localImages);
                      }}
                    >
                      {t("Local")}
                    </button>
                  </Tooltip>
                </div>
                <p className="label">{t("Sort_by")}</p>
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <Select
                      defaultValue="date"
                      onChange={(e) => setDropDownValue(e.target.value)}
                    >
                      <MenuItem value="date">{t("Date_uploaded")}</MenuItem>
                      <MenuItem value="desc">{t("Description")}</MenuItem>
                      <MenuItem value="file">{t("File_name")}</MenuItem>
                      <MenuItem value="size">{t("Image_size")}</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </Status>
            <GalleryDetails>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="full"
                name="radio-buttons-group"
                onChange={(e) => {
                  setRadioInputValue(e.target.value);
                  setShowImage("");
                }}
              >
                <Tooltip title={t("Full_page")} className="title">
                  <FormControlLabel
                    value="full"
                    control={
                      <Radio
                        checkedIcon={<CheckedIcon />}
                        icon={<UnCheckedIcon />}
                      />
                    }
                    label={t("Full_page")}
                  />
                </Tooltip>
                <Tooltip title={t("Insert")} className="title">
                  <FormControlLabel
                    value="insert"
                    control={
                      <Radio
                        checkedIcon={<CheckedIcon />}
                        icon={<UnCheckedIcon />}
                      />
                    }
                    label={t("Insert")}
                  />
                </Tooltip>
              </RadioGroup>
              <GalleryWrapper>
                {radioInputValue === "full" && sharedImages && !localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        ?.filter((item) => {
                          if (item?.fullPage) {
                            return item?.shared;
                          }
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${
                                  el?.description
                                } : ${verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD-MMM-YY"
                                )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, fullImagesArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "full" && !sharedImages && localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        ?.filter((item) => {
                          if (item?.fullPage) {
                            return !item?.shared;
                          }
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${
                                  el?.description
                                } : ${verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD-MMM-YY"
                                )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, fullImagesArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "full" && sharedImages && localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, fullImagesArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, fullImagesArray)
                        ?.filter((item) => {
                          return item?.fullPage;
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${
                                  el?.description
                                } : ${verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD-MMM-YY"
                                )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, fullImagesArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "insert" &&
                sharedImages &&
                !localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        ?.filter((item) => {
                          if (!item?.fullPage) {
                            return item?.shared;
                          }
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${
                                  el?.description
                                } : ${verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD-MMM-YY"
                                )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, insertClonedArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "insert" &&
                !sharedImages &&
                localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        ?.filter((item) => {
                          if (!item?.fullPage) {
                            return !item?.shared;
                          }
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${
                                  el?.description
                                } : ${verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD-MMM-YY"
                                )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, insertClonedArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}

                {radioInputValue === "insert" && sharedImages && localImages ? (
                  <>
                    {sortAndFilter(dropDownValue, insertClonedArray).length !==
                      0 &&
                      sortAndFilter(dropDownValue, insertClonedArray)
                        ?.filter((item) => {
                          return !item?.fullPage;
                        })
                        ?.map((el, index) => {
                          return (
                            <>
                              <Tooltip
                                title={`${
                                  el?.description
                                } : ${verboseDateToString(
                                  el?.uploadedUtc,
                                  "DD-MMM-YY"
                                )}`}
                              >
                                <div
                                  className="data-wrapper"
                                  id={el?.id}
                                  onClick={(e) => {
                                    renderImage(e, insertClonedArray);
                                    dragStart(el);
                                  }}
                                  onDragStart={() => dragStart(el)}
                                >
                                  <div className="image-wrapper">
                                    <img
                                      src={el?.base64data}
                                      id={el?.id}
                                      alt="img"
                                    />
                                  </div>
                                  <p
                                    style={{ cursor: "pointer" }}
                                    id={el?.id}
                                    key={index}
                                    draggable
                                    onDragStart={() => dragStart(el)}
                                    onClick={() => dragStart(el)}
                                  >
                                    {el?.description}
                                  </p>
                                </div>
                              </Tooltip>
                            </>
                          );
                        })}
                  </>
                ) : (
                  <></>
                )}
              </GalleryWrapper>
            </GalleryDetails>
          </GallerySection>
        </CenterSection>
      </Wrapper>

      <Modal
        open={alertMsg.get()}
        onClose={() => {
          alertMsg.set(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{t("Discard_changes_to_campaign")}?</p>
            <div className="action-btn">
              <button
                className="primary"
                onClick={() => {
                  alertMsg.set(false);
                  navigateToCampaigns();
                }}
              >
                {t("Yes")}
              </button>
              <button
                onClick={() => {
                  alertMsg.set(false);
                }}
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditCampaign;
